import React, {Component} from 'react';
import styles from "./dongtai.module.css";
import {FILE_URL} from "../../../util/constants";
import back from "../../../img/ic_back.png";
import icDel from '../../../img/delete.png';
import icDianzan0 from '../../../img/ic_dianzan_gray.png'
import icDianzan1 from '../../../img/ic_dianzan_red.png'
import icComment from '../../../img/ic_comment.png'

import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';


const Dongtai = props => (

    <div className={styles.root}>
        <div className={styles.menubar}>
            <img className={styles["img-back"]} src={back} onClick={props.onRequestClose}/>
            <div className={styles["modal-title"]}>动态详情</div>
        </div>

        <div className={styles.container}>

            <div className={styles["container-bottom"]}>

                <div className={styles['list-item']}>
                    <div className={styles['list-item-top']}>
                        <img
                            className={styles['list-item-touxiang']}
                            src={props.info.teacher_img}
                            onError={props.handleImageErrored.bind(this, '')}
                        />
                        <div className={styles['div-name']}>
                            <div className={styles['item-name']}>{props.info.teacher_name}</div>
                            <div className={styles['item-date']}>{props.info.date}</div>
                        </div>
                        {
                            props.info.dongtai_del == '1' ?
                                <img className={styles["img-del"]} src={icDel} onClick={props.deleteDongtai}/>
                                : null
                        }

                    </div>
                    <div className={styles['list-item-bottom']}>

                        <div className={styles["div-content"]}>
                            {props.info.content}
                        </div>

                        {/*<div className={styles["container-photo"]}>*/}
                            {/*{props.photoList.map((item0, index, array) => {*/}
                                {/*return (*/}
                                    {/*<img className={props.photoList.length > 1 ? styles.photo : styles.photo2}*/}
                                         {/*src={item0.img}/>*/}
                                {/*)*/}
                            {/*})*/}
                            {/*}*/}
                        {/*</div>*/}

                        <div className={styles["container-photo"]}>
                            <PhotoProvider >
                            {props.photoList.map((item0, index0, array) => {
                                return (

                                        <PhotoView src={item0.img}>
                                            <img className={props.photoList.length > 1 ? styles.photo : styles.photo2} src={item0.img} alt=""
                                                 onError={props.handleImageErrored3.bind(this, index0)}/>
                                        </PhotoView>

                                )
                            })
                            }
                            </PhotoProvider>
                        </div>




                        <div className={styles["container-photo"]}>
                            {props.huodong_suyang.map((item, index, array) => {
                                return (
                                    <div className={styles["item-suyang"]}>{item.name}</div>
                                )
                            })
                            }
                        </div>

                        <div className={styles["container-num"]}>
                            <div className={styles["div-liulan"]}>浏览{props.info.pageview}次</div>
                            <div className={styles["div-dianzan"]} onClick={props.dianzanMethod}>
                                <img className={styles["img-dianzan"]}  src={props.dianzan_status=='1'?icDianzan1:icDianzan0}/>
                                <div>{props.dianzannum}</div>
                            </div>
                            <div className={styles["div-dianzan"]}>
                                <img className={styles["img-dianzan"]} src={icComment}/>
                                <div>{props.info.commentnum}</div>
                            </div>

                        </div>


                        <div className={styles["container-comment"]}>
                            {props.huifu_list.map((item, index, array) => {
                                return (
                                    <div className={styles["list-item-comment"]}>
                                        <div className={styles['list-item-top']}>
                                            <img
                                                className={styles['list-item-touxiang']}
                                                src={item.img}
                                                onError={props.handleImageErrored2.bind(this, index)}
                                            />
                                            <div className={styles['div-name']}>
                                                <div className={styles['item-name']}>{item.name}</div>
                                                <div className={styles['item-date']}>{item.time}</div>
                                            </div>

                                        </div>
                                        <div>
                                            {item.huifu_content}
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>

                        <div className={styles["container-input"]}>
                            <textarea
                                className={styles["input-name"]}
                                placeholder='写下你的评论'
                                value={props.inputValue}
                                autoComplete="off"
                                onChange={(e) => {
                                    props.inputChange(e.target.value);
                                }}/>
                            <div className={styles["bt-send"]} onClick={props.sendComment}>提交</div>
                        </div>

                    </div>

                </div>


            </div>


        </div>
    </div>

)

export default Dongtai;
